const atualizarDepartamentos = (state, departamentos) => {
    state.departamentos = departamentos;
}

const atualizarDepartamento = (state, departamento) => {
    state.departamento = departamento;
}

const addDepartamento = (state, departamento) => {
    if (!departamento || departamento.id == null) return;

    state.departamentos.push(JSON.parse(JSON.stringify(departamento)));
}

const updateDepartamento = (state, departamento) => {
    if (!departamento || departamento.id == null) return;

    const index = state.departamentos.findIndex(item => item.id === departamento.id);
    if (index >= 0) {
        state.departamentos.splice(index, 1, JSON.parse(JSON.stringify(departamento)));
    }
}

export default {
    atualizarDepartamentos,
    atualizarDepartamento,
    addDepartamento,
    updateDepartamento
}
